import { useMemo } from 'react';
import { useSessionContext } from '../contexts/SessionContext';
import type { PlayerPermissions } from '@roll1/shared';
import { DEFAULT_PLAYER_PERMISSIONS } from '@roll1/shared';

export interface ResolvedPermissions extends PlayerPermissions {
  /** Whether the current user is GM (all permissions granted) */
  isGM: boolean;
}

/**
 * Hook that resolves permissions for the current user.
 * GM always has all permissions granted.
 */
export function usePermissions(): ResolvedPermissions {
  const { isGM, sessionSettings } = useSessionContext();

  return useMemo(() => {
    if (isGM) {
      return {
        moveOtherTokens: true,
        drawOnMap: true,
        viewOtherSheets: 'full' as const,
        createNotes: true,
        useAi: true,
        addTokens: true,
        isGM: true,
      };
    }

    const perms = sessionSettings.playerPermissions ?? DEFAULT_PLAYER_PERMISSIONS;
    return {
      ...perms,
      isGM: false,
    };
  }, [isGM, sessionSettings.playerPermissions]);
}
